<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>展位列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 卡片 -->
        <el-card class="box-card" style="margin-top:20px">
            <!-- 搜索  新增-->

            <el-form
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    label-width="80px"
                    size="mini"
                    autocomplete="on"
            >
                <el-form-item label="标题" >
                    <el-input v-model="searchForm.name" clearable type="text"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="success" @click="searchSubmit()">搜索</el-button>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary"  @click="addData">新增</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格 -->
            <el-table
                    ref="multipleTable"
                    size="mini"
                    :data="tableLoadData"
                    stripe
                    border
            >
                <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
                <el-table-column
                        label="标题"
                        width="400"
                        prop="title"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>
                <el-table-column
                        label="所属分类"
                        width="120"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
            <span>
               {{scope.row.category!=null?scope.row.category.name:""}}
               {{ scope.row.cat_id}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="所属商家"
                        width="120"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
            <span>
               {{scope.row.shop!=null?scope.row.shop.name:""}}
               </span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="发布日期"
                        width="200"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.add_time | dateFormat }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="100">
                    <template slot-scope="scope">
                        <el-button  type="text" size="small" @click="del(scope.row)">删除</el-button>
                        <el-button @click="handleClick(scope.row)"  type="text" size="small">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="block" style="margin-top:10px">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </el-card>
        <!-- 新增编辑弹框 -->

    </div>
</template>

<script>
    import moment from 'moment'     //日期时间转换

    export default {
        name: "newsList",
        components: {
        },
        props: {},
        data() {
            return {
                // 搜索
                searchForm: {
                    name: "",
                },
                searchRules: {
                    name: [
                        { required: true, message: "请输入文章标题", trigger: "blur" }
                    ],
                },
                // 数据
                tableLoadData: [],
                pageNum:1,// 当前页码
                pageSize:10,// 每页大小
                total:0,//总条目数

                showType: '',

                roleList: [],

                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                        {
                            min: 3,
                            max: 15,
                            message: "长度在 3 到 15 个字符",
                            trigger: "blur",
                        }
                    ],

                },

                dialogFormVisible: false,
                title: '',
                form: {
                    name: '',
                },

            };
        },
        created() {
            this.showType = this.$route.query.showType;
            console.log(this.showType,888);
            this.DataList()
            this.departData()
        },
        mounted() {
        },
        filters: {
            /**
             * @param {
             *
             * }
             */
            //时间格式化
            dateFormat(add_time) {
                if (add_time == undefined) {
                    return "";
                }
                return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
            },
            statusFilter(status) {
                if (status == 0) {
                    return "待审核";
                } else if (status == 1) {
                    return "已审核";
                } else if (status == 2) {
                    return "已出单";
                } else if (status == 3) {
                    return "已完成";
                } else if (status == 4) {
                    return "取保";
                } else if (status == 5) {
                    return "退单";
                }
            },

        },
        methods: {
            handleClick(row){
                this.$router.push('/boothForm?id='+row.id)
            },
            goCategory(){
                this.$router.push('/newsCategory')
            },
            indexMethod(index) {
                return (this.pageNum - 1) * this.pageSize + index + 1
            },
            DataList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    showType: this.showType,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    parent_id:sessionStorage.getItem('shop_id')
                }

                this.$axios.newsListP(param).then(res=>{
                    if(res.code == 200){
                        //  console.log(res,1111);
                        this.tableLoadData = res.data.data
                        this.total = res.data.total
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },
            // 设置每页条数
            handleSizeChange(newSize) {
                this.pageSize = newSize
                this.DataList()
            },
            // 分页跳转
            handleCurrentChange(newPage) {
                this.pageNum = newPage
                this.DataList()
            },
            departData(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                }
                this.$axios.findTree(param).then(res=>{
                    if(res.code == 200){
                        this.rightslist = res.data.data
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },

            // 新增
            addData() {
                // this.title = '新增'
                // this.form = {
                //   name: '',
                // }
                // this.dialogFormVisible = true
                this.$router.push('/boothForm')
            },
            handelEdit(index) {
                this.id = index.data.row.id
                this.title = '编辑'
                this.form = {
                    name: this.name,
                }
                this.dialogFormVisible = true
                // this.form = {...row};
                // 或者
                this.form = JSON.parse(JSON.stringify(index.data.row))
            },

            reset_dialogForm(formName) {
                this.dialogFormVisible = false
                this.$nextTick(() => {
                    this.$refs[formName].resetFields()
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(!this.id){
                            const param = {
                                name: this.form.name,
                                operator_id: sessionStorage.getItem('user_id'),
                                company_id: sessionStorage.getItem('company_id'),
                                access_token: sessionStorage.getItem('token'),
                            }
                            this.$axios.newsSave(param).then(res =>{
                                console.log(res,7777);
                                if(res.code == 200){
                                    this.DataList()
                                    this.$message.success(res.msg)
                                    this.dialogFormVisible = false
                                }else{
                                    this.$message.error(res.msg);
                                }
                            })
                        }else{
                            const param = {
                                id: this.form.id,
                                name: this.form.name,
                                operator_id: sessionStorage.getItem('user_id'),
                                company_id:sessionStorage.getItem('company_id'),
                                access_token:sessionStorage.getItem('token'),
                            }
                            this.$axios.insuranceCorpSave(param).then(res =>{
                                if(res.code == 200){
                                    this.$message.success(res.msg)
                                    this.DataList()
                                    this.dialogFormVisible = false
                                }else{
                                    this.$message.error(res.msg);
                                }
                            })
                        }

                    }
                })
            },
            // searchSubmit() {
            //   const param = {
            //       queryParams: this.searchForm.name,
            //       company_id:sessionStorage.getItem('company_id'),
            //       access_token:sessionStorage.getItem('token'),
            //       page: this.pageNum,
            //       pageSize: this.pageSize
            //   }
            //   this.$refs.searchForRef.validate((valid) => {
            //     if (valid) {
            //       this.$axios.insuranceCorpList(param).then(res=>{
            //         if(res.code == 200){
            //           this.tableLoadData = res.data.data
            //           this.total = res.data.total
            //         }
            //       })
            //     }
            //   })
            // },

            del(e) {
                console.log(e);
                this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const param = {
                        operator_id: sessionStorage.getItem('user_id'),
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                        id: e.id,
                    }
                    this.$axios.newsDel(param).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.pageNum=1;
                            this.total=0;
                            this.DataList()
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).catch(error=>{
                        console.log(error);
                    })
                }).catch(() => {
                    // 点击取消:不删除了
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                    this.DataList()
                });
                this.teamDialog = false
            },


        },
    };
</script>
<style>

</style>
